export function speciesId(name: string): string {
  return name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}

export function scrollToProjectHash(hash: string): () => void {
  let id: string;
  try { id = decodeURIComponent(hash.slice(1)); } catch { return () => {}; }
  let attempts = 0;
  const timer = window.setInterval(() => {
    const target = document.getElementById(id);
    if (target) {
      target.scrollIntoView({ block: "start" });
      window.clearInterval(timer);
    } else if (++attempts >= 40) window.clearInterval(timer);
  }, 75);
  return () => window.clearInterval(timer);
}